import React from 'react';
import moment from 'moment';
import { YES_NO_OPTION } from 'components/EnrollmentV2/constants/enum';
import { translateGender } from 'components/EnrollmentV2/util/translation';

const ReviewApplicantInfo = ({ state }) => {
    return (
        <div className="row">
            <div className="col-md-5">
                <ul>
                    <li>
                        Last Name:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['lastName']}
                        </strong>
                    </li>
                    <li>
                        First Name:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['firstName']}
                        </strong>
                    </li>
                    <li>
                        Residence Address:{' '}
                        <strong>
                            {
                                state?.enrollment.page4.sub2[
                                    'permanentAddressLine1'
                                ]
                            }
                            {' '}
                            {
                                state?.enrollment.page4.sub2[
                                    'permanentAddressLine2'
                                ]
                            }
                        </strong>
                    </li>
                    <li>
                        City:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['permanentCity']}
                        </strong>
                    </li>
                    <li>
                        State:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['permanentState']}
                        </strong>
                    </li>
                    <li>
                        Zip Code:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['permanentZipCode']}
                        </strong>
                    </li>
                </ul>
            </div>
            <div className="col-md-5">
                <ul>
                    <li>
                        Mailing Address:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2[
                                'addressMailingSame'
                            ] !== YES_NO_OPTION['No'].toString()
                                ? (state?.enrollment.page4.sub2[
                                      'permanentAddressLine1'
                                  ] + ' ' + state?.enrollment.page4.sub2['permanentAddressLine2'])
                                : state?.enrollment.page4.sub2[
                                      'mailingAddressLine1'
                                  ] + ' ' + state?.enrollment.page4.sub2[
                                      'mailingAddressLine2'
                                  ]}
                        </strong>
                    </li>
                    <li>
                        Phone Number:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['primaryPhone']}
                        </strong>
                    </li>
                    <li>
                        Gender:{' '}
                        <strong>
                            {translateGender(
                                state?.enrollment.page4.sub2['gender']
                            )}
                        </strong>
                    </li>
                    <li>
                        Date of Birth:{' '}
                        <strong>
                            {moment(
                                state?.enrollment.page4.sub2['dateOfBirth']
                            ).format('MM/DD/YYYY')}
                        </strong>
                    </li>
                    <li>
                        Email:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['contactEmail']}
                        </strong>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default ReviewApplicantInfo;
